var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-home"},[_c('AppHeader'),_vm._v(" "),_c('AppMain',[_c('section',{staticClass:"app-home__top-bar"},[_c('CardPicker'),_vm._v(" "),_c('AppDescription')],1),_vm._v(" "),_c('CardDisplay')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }